import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../home/components/Header';
import { Footer } from '../home/components/Footer';
import { HeroSection } from './components/HeroSection';
import { ContactMethods } from './components/ContactMethods';
import { ContactForm } from './components/ContactForm';
import { InfoSection } from './components/InfoSection';
import { FAQSection } from './components/FAQSection';

export default function ContactPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('contact.meta.title');
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('contact.meta.description'));
    }
  }, [t]);

  const handleChatClick = () => {
    // Open chatbot - this would trigger the ChatBot component
    const chatButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (chatButton) {
      chatButton.click();
    }
  };

  const handleFaqClick = () => {
    const faqSection = document.getElementById('faq');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <HeroSection />
      <ContactMethods onChatClick={handleChatClick} onFaqClick={handleFaqClick} />
      <ContactForm />
      <InfoSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
